import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";

const anchor: CSSProperties = {
  color: greys.standard,
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline",
  },
};

const wrapper: CSSProperties = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

const container: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: greys.white,
  padding: 64,
  borderRadius: 10,
};

const caption: CSSProperties = {
  color: greys.slate,
  width: 230,
  textAlign: "center",
};

const topMargin: CSSProperties = {
  marginTop: spacing.xxlg,
};

const errorMessage: CSSProperties = {
  color: greys.slate,
};

export const styles = {
  wrapper,
  anchor,
  errorMessage,
  caption,
  container,
  topMargin,
};
